/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { getValidTickets } from './index';

type PropsType = {
  handleShowModal: () => void,
  handleToggleModalFor: () => void,
  selectedRows: [],
  handleRemoveDiscountGroup: () => void,
  handleSelectRow: () => void,
  handleToggledClearRows: () => void,
  handleSearch: () => void,
  toggledClearRows: boolean,
  contextEvent: {
    eventDetail: {
      tickets: [],
      permission: string
    }
  },
  isReadOnly: boolean
};

const EventPageDiscountCodesSearchbar = ({
  handleShowModal,
  handleToggleModalFor,
  selectedRows,
  handleRemoveDiscountGroup,
  handleSelectRow,
  handleToggledClearRows,
  toggledClearRows,
  contextEvent,
  handleSearch,
  isReadOnly
}: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const isLockActions = _.size(selectedRows) === 1;

  const handleSearchInput = (e: any) => {
    const val = e.target.value;

    debouncedChangeHandler(val);
  };

  const handleSubmitSearch = (val: any) => handleSearch(val);

  const debouncedChangeHandler = React.useMemo(
    () => _.debounce(handleSubmitSearch, 700)
    , []);

  return (
    <div className="container-fluid search-bar">
      <div className="s-table">
        <div className="s-cell">
          <div className="navbar-form" style={{ float:'none', padding: '1rem 0' }} role="search">
            <div className="input-group event-search" style={{ width:'100%' }}>
              <input
                className="form-control"
                type="text"
                placeholder="search"
                autoComplete="off"
                onChange={(e: SyntheticInputEvent<HTMLInputElement>): any => {
                  e.persist();
                  handleSearchInput(e);
                }}
              />
              <span className="input-group-btn" style={{ width:'30px' }}>
                <button className="btn btn-default btn-search" type="button">
                  <span className="icon icon-search" />
                </button>
              </span>
            </div>
          </div>
        </div>

        <div className="s-cell s-cell-buttons" style={{ width: '1%' }}>
          <ul className="nav">
            <li style={{ marginRight: '1rem' }} />

            <li
              style={{
                opacity: !isReadOnly && isLockActions ? 1 : 0.5,
                cursor: !isReadOnly && isLockActions ? 'pointer' : 'not-allowed'
              }}
            >
              <a
                href='#'
                style={{
                  pointerEvents: !isReadOnly && isLockActions ? 'auto' : 'none'
                }}
                onClick={(e: any) => {
                  e.preventDefault();

                  if (isLockActions) {
                    handleShowModal(true);
                    handleToggleModalFor('Clone');
                  }
                }}
              >
                <span>Clone</span>
                {isReadOnly && <span className="tooltiptext">You do not have access to this action</span>}
              </a>
            </li>

            <li
              style={{
                opacity: !isReadOnly && isLockActions ? 1 : 0.5,
                cursor: !isReadOnly && isLockActions ? 'pointer' : 'not-allowed'
              }}
              onClick={() => {
                if (isReadOnly) return;

                if (isLockActions) {
                  handleShowModal(true);
                  handleToggleModalFor('Edit');
                }
              }}
            >
              <a
                href='#'
                style={{
                  pointerEvents: !isReadOnly && isLockActions ? 'auto' : 'none'
                }}
              >
                <span>Edit</span>
                {isReadOnly && <span className="tooltiptext">You do not have access to this action</span>}
              </a>
            </li>

            <li
              style={{
                opacity: !isReadOnly && _.size(selectedRows) ? 1 : 0.5,
                cursor: !isReadOnly && _.size(selectedRows) ? 'pointer' : 'not-allowed'
              }}
            >
              <a
                href='#'
                style={{
                  pointerEvents: !isReadOnly && _.size(selectedRows) ? 'auto' : 'none'
                }}
                onClick={(e: any) => {
                  if (isReadOnly) return;

                  e.preventDefault();
                  context.handleShowSystemDialog(true, {
                    systemDialogType: 'warning',
                    systemDialogTitle: 'Hmmm...',
                    systemDialogContent: 'Remove the discount code?',
                    systemDialogCallback: async () => {
                      await handleRemoveDiscountGroup();
                    }
                  });
                }}
              >
                <span>Remove</span>
                {isReadOnly && <span className="tooltiptext">You do not have access to this action</span>}
              </a>
            </li>

            <li
              style={{
                opacity: !isReadOnly ? 1 : 0.5,
                cursor: !isReadOnly ? 'pointer' : 'not-allowed'
              }}
              onClick={() => {
                if (isReadOnly) return;

                handleSelectRow([]);
                handleToggledClearRows(!toggledClearRows);

                const isIssetValidTickets = _.size(getValidTickets(contextEvent.eventDetail.tickets));

                if (isIssetValidTickets) {
                  handleShowModal(true);
                  handleToggleModalFor('Create');
                } else {
                  context.handleShowSystemDialog(true, {
                    systemDialogType: 'warning',
                    systemDialogTitle: 'Hmmm...',
                    systemDialogContent: 'You must create at least one ticket first.'
                  });
                }
              }}
            >
              <a
                href='#'
                style={{
                  pointerEvents: isReadOnly ? 'none' : 'auto'
                }}
              >
                <span>Create</span>
                {isReadOnly && <span className="tooltiptext">You do not have access to this action</span>}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EventPageDiscountCodesSearchbar;
